import * as tslib_1 from "tslib";
import { isPersonaInFavorites, isGroupInFavorites } from 'owa-favorites';
import { lazySetGroupIsSubscribed } from 'owa-group-shared-actions';
import { lazyEditGroup } from 'owa-group-edit-integration';
import { getGroupsStore } from 'owa-groups-shared-store';
import { lazyAddFavoriteGroup, lazyRemoveFavoriteGroup } from 'owa-mail-favorites-store';
import { lazyAddGroupMember } from 'owa-group-add-member-integration';
import getFavoriteIdForPersona from 'owa-mail-favorites-store/lib/selectors/getFavoritePersona';
import { selectGroup } from 'owa-mail-folder-forest-actions';
import { getSelectedNode } from 'owa-mail-folder-forest-store';
import { lazyNewMessage } from 'owa-mail-message-actions';
import { initializePersona as initializePersonaControl } from 'owa-persona';
import { lazyAddPopout, PopoutType } from 'owa-popout-store';
import { trace } from 'owa-trace';
import { addFavoritePersona, lazyRemoveFavoritePersona, lazyHandleToggleFavoritePersonaError, } from 'owa-mail-favorites-store';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { loadSubjectPickerModule } from 'owa-mail-subject-picker';
import { setLpcGroupDataUpdateListener, setLpcGroupMembersDataUpdateListener, setLpcUpdatePopupStateListener, } from './lpcDataUpdateListeners';
export default function initializePersona() {
    var _this = this;
    var config = {
        actionCallbacks: {
            composeMail: function (recipient, subject, body) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var toEmailAddress;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: 
                        // We need to load module to initialize all the orchestrators and mutators
                        return [4 /*yield*/, loadSubjectPickerModule()];
                        case 1:
                            // We need to load module to initialize all the orchestrators and mutators
                            _a.sent();
                            toEmailAddress = recipient
                                ? [{ EmailAddress: recipient, Name: recipient }]
                                : undefined;
                            lazyNewMessage.importAndExecute('LivePersonaCard', null /*groupId*/, toEmailAddress, subject, body);
                            return [2 /*return*/];
                    }
                });
            }); },
            readMail: function (mailId, properties) {
                trace.info('Persona action callback: readMail');
                lazyAddPopout.importAndExecute(PopoutType.ReadingPane, mailId);
            },
            toggleSubscribeToGroup: function (personaIdentifiers, newIsSubscribedState) {
                personaIdentifiers.Smtp &&
                    lazySetGroupIsSubscribed.importAndExecute(personaIdentifiers.Smtp, newIsSubscribedState);
            },
            editGroup: function (groupSmtpAddress) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var editGroup;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, lazyEditGroup.import()];
                        case 1:
                            editGroup = _a.sent();
                            editGroup(groupSmtpAddress);
                            return [2 /*return*/];
                    }
                });
            }); },
            addGroupMembers: function (groupSmtpAddress) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var addGroupMember;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, lazyAddGroupMember.import()];
                        case 1:
                            addGroupMember = _a.sent();
                            addGroupMember(groupSmtpAddress);
                            return [2 /*return*/];
                    }
                });
            }); },
        },
        dataCallbacks: {},
        dataUpdateBroadcaster: {
            setGroupUpdateListener: setLpcGroupDataUpdateListener,
            setGroupMembersUpdateListener: setLpcGroupMembersDataUpdateListener,
            updatePopupStateListener: setLpcUpdatePopupStateListener,
        },
    };
    config.actionCallbacks.favoritePersona = LPCFavoritePersona;
    config.actionCallbacks.unfavoritePersona = LPCUnfavoritePersona;
    config.dataCallbacks.getIsPersonaFavorited = function (personaId, callback) {
        if (personaId.PersonaType === 'Group') {
            var isFavorited = isGroupInFavorites(personaId.Smtp);
            callback({ isFavorited: isFavorited }, undefined);
        }
        else if (personaId.PersonaType === 'User') {
            var isFavorited = isPersonaInFavorites(personaId.OlsPersonaId, personaId.Smtp);
            callback({ isFavorited: isFavorited }, undefined);
        }
        else {
            callback({ isFavorited: undefined }, 'Persona type unsupported');
        }
    };
    initializePersonaControl(config);
}
function LPCFavoritePersona(personaId, callback, properties) {
    if (personaId.PersonaType === 'Group' && isControlFeatureEnabled('tri-favorites-roaming')) {
        favoriteGroup(personaId, callback);
    }
    else if (personaId.PersonaType === 'User') {
        favoritePerson(personaId, callback, properties);
    }
    else {
        callback(false, 'Persona type unsupported');
    }
}
function LPCUnfavoritePersona(personaId, callback) {
    if (personaId.PersonaType === 'Group' && isControlFeatureEnabled('tri-favorites-roaming')) {
        unfavoriteGroup(personaId, callback);
    }
    else if (personaId.PersonaType === 'User') {
        unfavoritePerson(personaId, callback);
    }
    else {
        callback(false, 'Persona type unsupported');
    }
}
function favoritePerson(personaId, callback, properties) {
    // Although LPC can contain OLS personaId, sometimes it is not the one which is returned from findPeople api. Thus we rely only on email.
    var favoritePromise = addFavoritePersona(undefined, personaId.Smtp, properties.personaDisplayName, 'LivePersonaCard');
    favoritePromise.then(function () { return callback(true, undefined); }).catch(function (e) {
        // If an error was detected, the store has been rolled back
        callback(false, e);
        lazyHandleToggleFavoritePersonaError.importAndExecute(e);
    });
}
function unfavoritePerson(personaId, callback) {
    // Although LPC can contain OLS personaId, sometimes it is not the one which is returned from findPeople api. Thus we rely only on email.
    var favoriteId = getFavoriteIdForPersona(undefined, personaId.Smtp);
    var unfavoritePromise = lazyRemoveFavoritePersona.importAndExecute(favoriteId, 'LivePersonaCard');
    unfavoritePromise.then(function () { return callback(true, undefined); }).catch(function (e) {
        // If an error was detected, the store has been rolled back
        callback(false, e);
        lazyHandleToggleFavoritePersonaError.importAndExecute(e);
    });
}
function favoriteGroup(personaId, callback) {
    var groupsStore = getGroupsStore();
    var group = groupsStore.groups.get(personaId.Smtp.toLowerCase());
    if (!group) {
        return;
    }
    if (!isGroupInFavorites(personaId.Smtp)) {
        lazyAddFavoriteGroup
            .import()
            .then(function (addFavoriteGroup) {
            return addFavoriteGroup(personaId.Smtp, group.basicInformation.DisplayName, 'GroupNodeFavoriteButton');
        })
            .then(function () { return callback(true, undefined); });
    }
    else {
        callback(false, 'Group is already favorited');
    }
}
function unfavoriteGroup(personaId, callback) {
    var groupsStore = getGroupsStore();
    var group = groupsStore.groups.get(personaId.Smtp.toLowerCase());
    if (!group) {
        return;
    }
    if (isGroupInFavorites(personaId.Smtp)) {
        // Reset the folder selection to the same group in the group list if unfavorite a selected node
        var selectedNode = getSelectedNode();
        if (selectedNode.id && selectedNode.id.toLowerCase() == personaId.Smtp.toLowerCase()) {
            selectGroup(personaId.Smtp, 'groups' /* treeType */);
        }
        lazyRemoveFavoriteGroup
            .import()
            .then(function (removeFavoriteGroup) {
            return removeFavoriteGroup(personaId.Smtp, 'GroupNodeFavoriteButton');
        })
            .then(function () { return callback(true, undefined); });
    }
    else {
        callback(false, 'Group is already unfavorited');
    }
}
//# sourceMappingURL=initializePersona.js.map